import EventEmitter from 'events'
import Actions from './Actions';

EventEmitter.defaultMaxListeners = 1000;

//  Global event emitter instance
const eventInstance = new EventEmitter();

/**
 * Gets the singleton emitter instance
 * @return {EventEmitter}
 */
export const getEventEmitter = () => eventInstance;

/**
 * Emits the action specified alongside the payload
 * @param {Actions} action The event action name
 * @param payload Additional payload for the event
 */
export const broadcastEvent = (action, payload) => {
    eventInstance.emit(action , payload );
};

/**
 * Global events Emit 'user_profile_updated' event
 * @param media
 */
export const notifyUserProfileChanged = (media) => {
    broadcastEvent(Actions.UserProfileImageUpdated, media );
};

/**
 * Request notification update
 * @param payload
 */
export const notifyRequestUpdate = (payload) => {
    broadcastEvent(Actions.TractorRequestUpdate , payload);
};

/**
 * Payment update
 * @param payload
 */
export const notifyPaymentsUpdate = (payload) => {
    broadcastEvent(Actions.PaymentsUpdate , payload);
};

/**
 * Operator request update
 * @param payload
 */
export const notifyOperatorRequestUpdate = (payload) => {
    broadcastEvent(Actions.OperatorRequestUpdate , payload);
};


/**
 * Global event Emit 'user_info_updated' event
 * @param user
 */
export const notifyUserInfoChanged = (user) => {
    broadcastEvent( Actions.UserInfoUpdated , user );
};

export const notifyBrowserUnload = () => {
    broadcastEvent( Actions.BrowserUnload);
};

export const handleBrowserUnload = (listener) => {
    subscribe(Actions.BrowserUnload, listener , true );
};

/**
 * Global event: Emits 'user_logout' event
 */
export const notifyLogout = () => {
    broadcastEvent(Actions.UserLogout);
};

/**
 * Subscribes to the event action once
 * @param action The event action name
 * @param listener The callback
 * @param once Determines the listener should be invoked once or multiple
 */
export const subscribe = (action , listener , once = false) => {

    if(once === true){
        return  eventInstance.once(action,listener);
    }

    return  eventInstance.on(action,listener);
};

export default eventInstance;


// WEBPACK FOOTER //
// ./src/common/Events/EventSource.js